// 接口
import { createReceivableList, createPaymentList } from '@/api/financeApi'
import { receivableTemplate, paymentTemplate } from '@/config'

export const SubmitFormBaseModel = {
  title: '--',
  submitDingTalkShow: null,
  postUrl: '',
  postData: {},
  batchTemplate: '',
  templateUrl: '',
}
export const ReceivableSubmitFormBaseModel = {
  title: '收款',
  submitDingTalkShow: 1,
  postUrl: createReceivableList,
  postDataKey: {
    urlKey: 'receivableOrderExcelUrl',
    urlListKey: 'receivableVoucherUrlList',
  },
  templateUrl: receivableTemplate,
  btnTitle: '提交',
}
export const PaymentSubmitFormBaseModel = {
  title: '付款',
  submitDingTalkShow: 22,
  postUrl: createPaymentList,
  postDataKey: {
    urlKey: 'paymentOrderExcelUrl',
    urlListKey: 'paymentVoucherUrlList',
  },
  templateUrl: paymentTemplate,
  btnTitle: '提 交',
}


export const UploadConfigMapper = new Map([
  ['receivable', 'finance_collection_agreement_pic'],
  ['payment', 'finance_pay_agreement_pic'],
])
